import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SubscriptionSummarySlice {
  isOpen: boolean;
  isOpenSeatManageModal?: boolean;
}

const initialState: SubscriptionSummarySlice = {
  isOpen: false,
  isOpenSeatManageModal: false,
};

export const subscriptionSummarySlice = createSlice({
  name: "subscriptionSummary",
  initialState,
  reducers: {
    setSubscriptionSummaryModalOpen: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isOpen = action.payload;
    },
    setOpenSeatManageModal: (state, action: PayloadAction<boolean>) => {
      state.isOpenSeatManageModal = action.payload;
    },
  },
});

export const { setSubscriptionSummaryModalOpen, setOpenSeatManageModal } =
  subscriptionSummarySlice.actions;

export default subscriptionSummarySlice.reducer;
